    <p-toast></p-toast>
    <app-page-shell>
      <app-page-hero eyebrow="HR Migration" title="Migration Proposals" subtitle="Review existing portal users and tenant drivers before creating HR employee profiles.">
      </app-page-hero>

      @if (loading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
      }

      <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

      <app-page-data-panel title="Proposals" subtitle="Approval creates an HR employee and links the source record. Dismissal keeps the source unchanged." [resultText]="proposals.length + ' proposals'">
        <div actions>
          <p-inputGroup class="hero-filter">
            <p-inputGroupAddon><i class="fa-solid fa-filter"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="migrationStatusFilter" [options]="statusOptions" [(ngModel)]="statusFilter" [showClear]="true" (onChange)="load()" styleClass="w-full"></p-select>
              <label for="migrationStatusFilter">Status</label>
            </p-iftaLabel>
          </p-inputGroup>
          @if (canManageMigration) {
            <button pButton type="button" label="Refresh Proposals" icon="pi pi-refresh" (click)="refresh()" [loading]="loading"></button>
          }
        </div>
        <p-table [value]="proposals" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '980px' }">
          <ng-template pTemplate="header">
            <tr>
              <th>Source</th>
              <th>Person</th>
              <th>Contact</th>
              <th>Category</th>
              <th>Status</th>
              <th>Reason</th>
              <th style="width: 12rem">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-proposal>
            <tr>
              <td>
                <div class="main-cell">
                  <strong>{{ proposal.sourceType }}</strong>
                  <span>#{{ proposal.sourceEntityId }}</span>
                </div>
              </td>
              <td>{{ proposal.displayName }}</td>
              <td>
                <div class="main-cell">
                  <span>{{ proposal.emailAddress || '-' }}</span>
                  <small>{{ proposal.phoneNumber || '-' }}</small>
                </div>
              </td>
              <td><p-tag [value]="format(proposal.workerCategory)" severity="info"></p-tag></td>
              <td><p-tag [value]="proposal.proposalStatus" [severity]="proposal.proposalStatus === 'PENDING' ? 'warn' : proposal.proposalStatus === 'APPROVED' ? 'success' : 'secondary'"></p-tag></td>
              <td>{{ proposal.proposalReason || proposal.dismissedReason || '-' }}</td>
              <td>
                <div class="actions">
                  @if (canManageMigration) {
                    <button pButton type="button" label="Approve" size="small" icon="pi pi-check" [disabled]="proposal.proposalStatus !== 'PENDING'" (click)="approve(proposal)"></button>
                    <button pButton type="button" label="Dismiss" size="small" icon="pi pi-times" severity="secondary" [outlined]="true" [disabled]="proposal.proposalStatus !== 'PENDING'" (click)="openDismissDialog(proposal)"></button>
                  }
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="7">No migration proposals found.</td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>

      <p-dialog header="Dismiss Migration Proposal" [(visible)]="dismissDialogVisible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: 'min(560px, 96vw)' }">
        <app-page-form-section icon="fa-solid fa-code-merge" title="Dismiss Proposal" subtitle="Keep the source record unchanged and record why it should not become an HR employee.">
          <div class="dialog-form">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-user"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <textarea id="dismissReason" pTextarea [(ngModel)]="dismissReason" rows="4"></textarea>
                <label for="dismissReason">Dismiss reason</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
        </app-page-form-section>
        <ng-template pTemplate="footer">
          <button pButton type="button" label="Cancel" severity="secondary" [outlined]="true" (click)="dismissDialogVisible = false"></button>
          <button pButton type="button" label="Dismiss" icon="pi pi-check" severity="danger" [disabled]="!selectedProposal?.proposalId" (click)="confirmDismiss()"></button>
        </ng-template>
      </p-dialog>
    </app-page-shell>
